export default "__VITE_PUBLIC_ASSET__9517453f__"